"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
exports.getAttr = (el, attr) => {
    return el.getAttribute(constants_1.OSYS_ATTRS[attr]);
};
//# sourceMappingURL=getAttr.js.map